import config from '../../config';
import { PRINT_PAGE_SIZES } from '../../constants';

export default class PrintButtonComponentModalCtrl {
  HTML_2_PDF_PRINTING_ENABLED = config.HTML_2_PDF_PRINTING_ENABLED;

  constructor(
    Authentication,
    PrintService,
    uppercaseFirstFilter,
    $rootScope,
    $window,
    args,
    prepare,
    type,
    title,
    caption,
    batchPrint
  ) {
    'ngInject';

    Object.assign(this, {
      Authentication,
      PrintService,
      uppercaseFirstFilter,
      $rootScope,
      $window,
      args,
      prepare,
      type,
      title,
      caption,
      batchPrint,
    });

    const {
      printPreferenceBlackAndWhite,
      printPreferenceOrientation,
      printShowScheduleEndTimes,
      printScale,
    } = Authentication.user.settings.clientFlags;

    this.blackAndWhite = Boolean(printPreferenceBlackAndWhite);
    this.orientation = printPreferenceOrientation || 'Landscape';
    this.size = Authentication.user.settings.printPaperSize;
    this.showScheduleEndTimes = printShowScheduleEndTimes;
    this.printScales = [100, 50];
    this.printScale = printScale ?? 100;

    this.orientationOptions = [
      { label: 'Landscape', value: 'Landscape' },
      { label: 'Portrait', value: 'Portrait' },
    ];

    this.pageSizeOptions = PRINT_PAGE_SIZES;

    this.readyWhenPrepared();
  }

  async readyWhenPrepared() {
    if (this.prepare) {
      this.prepareResult = await this.prepare();
    }

    this.ready = true;
  }

  blackAndWhiteChanged() {
    this.Authentication.user.settings.clientFlags.printPreferenceBlackAndWhite = this.blackAndWhite;
    this.Authentication.syncSettings();
  }

  orientationChanged(value) {
    this.Authentication.user.settings.clientFlags.printPreferenceOrientation = value;
    this.Authentication.syncSettings();
  }

  sizeChanged(value) {
    this.Authentication.user.settings.printPaperSize = value;
    this.Authentication.syncSettings();
  }

  showScheduleEndTimesChanged() {
    this.Authentication.user.settings.clientFlags.printShowScheduleEndTimes =
      this.showScheduleEndTimes;
    this.Authentication.syncSettings();
  }

  printScaleChanged() {
    this.Authentication.user.settings.clientFlags.printScale = this.printScale;
    this.Authentication.syncSettings();
  }

  _printArgs = (result) => ({
    blackAndWhite: this.blackAndWhite,
    portrait: this.orientation === 'Portrait',
    pageSize: this.size,
    showScheduleEndTimes: this.showScheduleEndTimes,
    printScale: this.printScale / 100, // headless expects a fraction, not a percentage
    args: this.args,
    prepareResult: result || this.prepareResult,
  });

  print() {
    if (this.Authentication.isOrgFeatureEnabled('printing')) {
      if (this.batchPrint) {
        this.PrintService.printBatchHeadless(this.prepareResult.map(this._printArgs));
      } else {
        this.PrintService.printHeadless(this._printArgs());
      }
    }
  }

  openHeadlessLocalPreview() {
    const [payload, route] = this.PrintService.printHeadless(
      this._printArgs(),
      /* is local preview */ true
    );

    this.$window.localStorage['sling-web-headless-payload'] = payload;
    this.$window.open(
      `${config.SLING_APP_URL}/headless/headless.html?load-localstorage#!/${route}`,
      '_blank'
    );
  }

  openHeadlessLocalPreviewHtml2Pdf() {
    let args;

    args = this._printArgs();

    // TODO this is here just to satisfy printing PoC as this code is timesheets specific, but it's the only place in the web app where
    // we do batch printing and I wanted to keep the current printing solution in workable shape; hence this shitty code below
    if (this.batchPrint) {
      const prepared = this.prepareResult[0];
      prepared.timesheetsCtrl.timesheets = this.prepareResult.reduce(
        (prev, next) => [...prev, next.timesheetsCtrl.timesheets],
        []
      );
      prepared.timesheetsCtrl.batchPrint = true;

      args = this._printArgs(prepared);
    }

    const [payload, route] = this.PrintService.printHeadless(args, true);

    this.$window.localStorage['sling-web-headless-payload'] = payload;
    this.$window.open(`${config.SLING_APP_URL}/print/?load-localstorage#!/${route}`, '_blank');
  }
}
